<template>
  <section class="userPlatforms">
    <h2 class="userPlatforms__title">Plataformas</h2>

    <div class="userPlatforms__contentRoles">
      <li class="userPlatforms__checkbox" v-for="platform in streamingOptions" :key="platform.name">
        <input class="mycheck " type="checkbox" :id="platform.name" :value="platform.name" v-model="platform.isSelected" @change="checkPlatform(platform, platform.isSelected)" />
        <label class="userPlatforms__label" :for="platform.name">{{ platform.name }}</label>
      </li>
    </div>
    <div v-for="item in platformsFilter" :key="item._id || item.platformId._id">
      <PlatformCard
        :user="user"
        :credentials="item"
        :platform="item.platformId"
        :initially-open="false"
        :isCreationMode="!item?.userId"
        :history="history[item.platformId.name] || { active: [], inActive: [] }"
        @onChange="onChange"
        @onSave="saveCredential"
        @card-validation-change="onCardValidationChange"
      />
    </div>
  </section>
</template>

<script>
  import { getPlatforms, getPlatformsAccounts, createPlatformAccount, putPlatformAccount } from "../../../services/platforms";
  import { mapGetters } from "vuex";

  import PlatformCard from "../../organisms/PlatformCard.vue";

  export default {
    components: { PlatformCard },
    data() {
      return {
        streaming: ["LiveJasmin", "Streamate"],
        storeKeys: {
          LiveJasmin: {
            email: "jasminUser",
            password: "jasminPassword",
          },
          Streamate: {
            email: "streamateUser",
            password: "streamatePassword",
          },
        },
        streamingOptions: [],
        platformSelected: null,
        platform: [],
        myPlatforms: [],
        platformsFilter: [],
        body: {},
        history: {
          active: [],
          inActive: [],
        },
        cardsValidity: {},
      };
    },
    computed: {
      ...mapGetters("user", ["getProfile"]),
      myProfile() {
        return this.getProfile;
      },
      user() {
        return this.$store.state.user.dataUser;
      },
      streamingPlatforms() {
        return this.platform.filter((item) => item.status === "active");
      },
      isEditUser() {
        return !!this.user?._id;
      },
      formIsValid() {
        if (!this.newPlatforms.length) return true;

        return this.newPlatforms.every((p) => this.cardsValidity[p.platformId.name]);
      },
      newPlatforms() {
        return this.platformsFilter.filter((p) => !p._id);
      },
    },
    methods: {
      chageItem(key) {
        const { name, value } = event.target;
        this.$store.state.user.dataUser[this.storeKeys[name][key]] = value;
      },
      createStreamingOptions() {
        const allOptions = { name: "Todas", isSelected: false };

        const options = this.platform
          .filter((p) => p.status === "active")
          .map((p) => {
            const hasActiveCred = this.myPlatforms.some((m) => m.platformId.name === p.name && m.isActive);

            return {
              name: p.name,
              isSelected: hasActiveCred,
              ...p,
            };
          });

        allOptions.isSelected = options.every((o) => o.isSelected);

        options.push(allOptions);
        return options;
      },

      addPlatform(platformName) {
        const exists = this.streamingOptions.some((o) => o.name === platformName);
        if (exists) return;

        const p = this.platform.find((x) => x.name === platformName);
        if (!p) return;

        this.streamingOptions.push({ name: p.name, isSelected: true, ...p });
        this.platformsFilter.push({ platformId: p });
      },
      removePlatform(platformName) {
        this.streamingOptions = this.streamingOptions.filter((o) => o.name !== platformName && o.name !== "Todas");
        this.platformsFilter = this.platformsFilter.filter((x) => x.platformId.name !== platformName);
        if (this.storeKeys[platformName]) this.resetKeysInStore(platformName);
      },
      resetKeysInStore(platform) {
        Object.values(this.storeKeys[platform]).forEach((val) => (this.$store.state.user.dataUser[val] = ""));
      },
      checkPlatform(platform, newValue) {
        if (platform.name === "Todas") {
          this.streamingOptions.forEach((opt) => {
            if (opt.name !== "Todas") opt.isSelected = newValue;
          });

          if (newValue) {
            this.streamingPlatforms.forEach((p) => {
              const already = this.platformsFilter.some((f) => f.platformId.name === p.name);
              if (!already) this.platformsFilter.push({ platformId: p });
            });
          } else {
            this.myPlatforms.filter((acc) => acc.isActive).forEach((acc) => this.deactivateCredential(acc.platformId.name));

            this.platformsFilter = [];
            Object.keys(this.storeKeys).forEach((k) => this.resetKeysInStore(k));
          }

          if (!newValue) {
            this.cardsValidity = {};
            this.body = {};
          }

          return;
        }

        const allOption = this.streamingOptions.find((opt) => opt.name === "Todas");
        allOption.isSelected = this.streamingOptions.filter((o) => o.name !== "Todas").every((o) => o.isSelected);

        if (newValue) {
          const exists = this.platformsFilter.some((f) => f.platformId.name === platform.name);
          if (!exists) {
            const p = this.streamingPlatforms.find((item) => item.name === platform.name);
            this.platformsFilter.push({ platformId: p });
          }
        } else {
          this.platformsFilter = this.platformsFilter.filter((f) => f.platformId.name !== platform.name);
          if (this.storeKeys[platform.name]) this.resetKeysInStore(platform.name);

          this.deactivateCredential(platform.name);
          this.$delete(this.cardsValidity, platform.name);
          this.$delete(this.body, platform.name);
        }

        if (newValue) {
          const el = document.querySelector(".modalUserMagnament__contentData");
          if (el) {
            setTimeout(() => el.scrollTo({ top: el.scrollHeight, behavior: "smooth" }), 300);
          }
        }
      },

      updateStyles(reference, referenceLocal, response) {
        reference.style.display = response ? "none" : "block";
        referenceLocal.style["border-color"] = response ? "#d8d8d8" : "#bd0909";
      },

      buildHistory(records = [], platformObjs = []) {
        const base = platformObjs.reduce((acc, p) => {
          acc[p.name] = { active: [], inActive: [] };
          return acc;
        }, {});

        records.forEach((r) => {
          const name = r.platformId?.name;
          if (!name) return;
          if (!base[name]) base[name] = { active: [], inActive: [] };
          const bucket = r.isActive ? "active" : "inActive";
          base[name][bucket].push(r);
        });

        return base;
      },

      onChange({ input, platform }) {
        const id = input.id ?? input.target?.id;
        const value = input.value ?? input.target?.value;
        if (!id) return;

        const updated = { ...(this.body[platform.name] || {}), [id]: value };
        this.$set(this.body, platform.name, updated);
      },
      collectPayload() {
        return {
          selectedPlatforms: this.platformsFilter.map((p) => ({
            platformId: p.platformId._id,
            name: p.platformId.name,
          })),
          credentials: this.body,
        };
      },

      async saveCredential({ type, platform, user }) {
        if (!this.cardsValidity[platform.name]) {
          this.$toast.error(`Revisa los campos obligatorios de ${platform.name}`);
          return;
        }

        const account = this.myPlatforms.find((acc) => acc.platformId.name === platform.name && acc.isActive);
        const value = this.body?.[platform.name]?.[type];

        if (!value || !account._id) return;

        try {
          await putPlatformAccount(account._id, {
            userId: user._id,
            platformId: platform._id,
            createdBy: this.myProfile._id,
            [type]: value,
          });
          this.$toast.success(`${type} actualizado`);
        } catch (err) {
          console.error(err);
          this.$toast.error(`Error al actualizar ${type}`);
        }
      },

      async savePlatforms() {
        const userId = this.user?._id;

        if (!this.formIsValid) {
          this.$toast.error("Complete los campos antes de continuar");
          return false;
        }

        if (!userId) {
          this.$toast.error("Crea primero el usuario para poder guardar plataformas");
          return false;
        }

        const tasks = this.platformsFilter.flatMap(({ _id, platformId }) => {
          if (_id) return [];

          const data = Object.fromEntries(Object.entries(this.body[platformId.name] || {}).filter(([, v]) => v));

          return Object.keys(data).length ? [createPlatformAccount({ userId, platformId: platformId._id, createdBy: this.myProfile._id, isActive: true, ...data })] : [];
        });

        if (!tasks.length) {
          this.$toast.info("No hay credenciales nuevas para guardar");
          return true;
        }

        try {
          await Promise.all(tasks);
          this.$toast.success("Credenciales creadas correctamente");

          await this.fetchPlatformsData();
          this.processPlatformData();
          return true;
        } catch (err) {
          console.error(err);
          this.$toast.error("Error al crear credenciales");
          return false;
        }
      },

      async deactivateCredential(platformName) {
        const account = this.myPlatforms.find((acc) => acc.platformId.name === platformName && acc.isActive);

        if (!account?._id) return;

        try {
          await putPlatformAccount(account._id, {
            userId: account.userId,
            platformId: account.platformId._id,
            isActive: false,
          });

          account.isActive = false;
          this.$toast.success(`Credencial desactivada en ${platformName}`);
        } catch (err) {
          console.error(err);
          this.$toast.error(`Error al desactivar la credencial en ${platformName}`);
        }
      },
      formatDateEs(iso) {
        if (!iso) return false;

        return `Creado el ${new Date(iso).toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        })}`;
      },
      processPlatformData() {
        const datedRecords = this.myPlatforms.map((r) => ({
          ...r,
          createdAt: this.formatDateEs(r.createdAt),
        }));
        this.history = this.buildHistory(datedRecords, this.platform);

        this.platformsFilter = this.myPlatforms.filter((x) => x.isActive);
        this.streamingOptions = this.createStreamingOptions();
      },
      async fetchPlatformsData() {
        const { data: platformResp = [] } = await getPlatforms({});
        this.platform = platformResp;

        if (!this.user._id) return;

        const { data: accountsResp = {} } = await getPlatformsAccounts({
          _id: this.user._id,
        });

        this.myPlatforms = accountsResp.data || [];
      },
      async initProcess() {
        try {
          await this.fetchPlatformsData();
          this.processPlatformData();
        } catch (err) {
          console.error("Error en beforeMount", err);
          this.$toast.error("No se pudieron cargar las plataformas");
        }
      },
      onCardValidationChange({ platform, valid }) {
        this.$set(this.cardsValidity, platform, valid);
      },
      getPlatformData() {
        const userId = this.user?._id || null;
        const createdBy = this.myProfile?._id || null;

        const accounts = this.platformsFilter.map(({ platformId }) => {
          const name = platformId.name;
          const creds = this.body[name] || {};

          const doc = {
            userId,
            platformId: platformId._id,
            isActive: true,
            createdBy,
          };

          if (creds.userName) doc.userName = creds.userName;
          if (creds.password) doc.password = creds.password;
          if (creds.email) doc.email = creds.email;

          return doc;
        });

        return {
          accounts,
          isValid: this.formIsValid,
        };
      },
    },

    beforeMount() {
      this.initProcess();
    },
  };
</script>

<style lang="scss">
  .userPlatforms {
    @include Flex(column, flex-start, flex-start);
    width: 100%;
    gap: $mpadding;
    &__title {
      font-size: 20px;
      font-family: $newFont_semiBold;
      font-weight: 600;
      color: $primary-color;
      line-height: normal;
    }
    &__contentRoles {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr 1fr;
      width: 70%;
      gap: 13px;
    }
    &__checkbox {
      @include Flex(row, flex-start);
      width: 100%;
      gap: $mpadding / 2;
      > label {
        cursor: pointer;
        text-transform: capitalize;
        user-select: none;
      }
    }
    .mycheck {
      width: 20px;
      height: 20px;
      padding: 5px;
      border-radius: 6px;
      border-color: #c4c4c4;
      &:checked {
        background-color: $primary-color;
        border-color: $primary-color;
      }
    }
    &__label {
      font-family: $newFont_regular;
      font-size: 16px;
      font-weight: 400;
    }
    &__contentPlatform {
      @include Flex(column, flex-start, flex-start);
      width: 100%;
      gap: $mpadding / 1.5;
    }
    &__contentInput {
      width: 100%;
    }
    &__input {
      width: 100%;
      height: 40px;
      border: 1px solid $alto;
      border-radius: 6px;
      padding: 5px;
      &:focus {
        outline: none;
      }
    }
    &__error {
      display: none;
      margin-top: -10px;
      font-weight: 600;
      font-size: 0.8em;
      color: $primary-color;
    }
  }
</style>
